import React, { Component } from "react";
import ReactLoading from "react-loading";
import { producaov2 } from "../services/apis";
import "../assets/css/voittocoins.css";
import Modal from "react-modal";
import Slider from "react-slick";
import { getUserNode, isAuthenticatedNode } from "../services/auth_node";
import { verify_mobile } from "../utils/Utils";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "40%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

export default class VoittoCoins extends Component {
  state = {
    vts: { voittocoins: "0" },
    modalIsOpen: false,
    voittocoins_meus: {
      posicao: "",
      total: "",
    },
    data: [],
  };

  componentDidMount() {
    if (isAuthenticatedNode()) {
      Promise.all([
        producaov2.get(`ranking/voittocoins`),
        producaov2.get(`voittocoins`),
        producaov2.get(`ranking/voittocoins/${getUserNode().id}`),
      ])
        .then(([ranking, voittocoins, posicao]) => {
          this.setState({
            data: ranking.data,
            vts: voittocoins.data.voittocoins,
            load: true,
            voittocoins_meus: {
              posicao: posicao.data.rank,
              total: posicao.data.total,
            },
          });
        })
        .catch((err) => console.error(err));
    }
  }
  hover() {}

  minha_posicao() {
    this.setState({
      modalIsOpen: !this.state.modalIsOpen,
    });
  }

  position_minha() {
    return (
      <div>
        <center>
          <img
            style={{ width: "30%", paddingtop: "5%" }}
            src="https://files.voitto.com.br/ftp-files/images/icones/never_give_up_icon.png"
          />
          <br />
          <p>
            Sua posição no ranking é a{" "}
            {this.state.voittocoins_meus.posicao != undefined
              ? this.state.voittocoins_meus.posicao
              : ""}{" "}
            dentre{" "}
            {this.state.voittocoins_meus.total != undefined
              ? this.state.voittocoins_meus.total
              : ""}{" "}
            posições.
          </p>
          <br />
          <br />
          <button
            className="ui orange button"
            onClick={() => this.minha_posicao()}
            type="submit"
          >
            <b>Entendi</b>
          </button>
        </center>
      </div>
    );
  }

  como_ganhar_view() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    return (
      <div className="menurs_vts">
        <center>
          <div>
            <Slider {...settings}>
              <div>
                <p>
                  <i
                    style={{
                      zIndex: 9999999,
                      color: "black",
                      cursor: "pointer",
                      marginLeft: "94%",
                    }}
                    className="ui icon close"
                    onClick={() => this.setState({ como_ganhar: false })}
                  ></i>
                </p>
                <p className="classcal_p">Como conquistar seus VoittoCoins?</p>
                <img
                  className="div_cvcs"
                  src="https://files.voitto.com.br/ftp-files/assets/images/voittocoins/slide1.png"
                />
                <p className="classcal_p">Evoluir nos cursos</p>
                <botoes className="ui yellow basic huge fluid button fros">
                  03 VoittoCoins a cada lição assistida
                </botoes>
              </div>
              <div>
                <p>
                  <i
                    style={{
                      zIndex: 9999999,
                      color: "black",
                      cursor: "pointer",
                      marginLeft: "94%",
                    }}
                    className="ui icon close"
                    onClick={() => this.setState({ como_ganhar: false })}
                  ></i>
                </p>
                <p className="classcal_p">Como conquistar seus VoittoCoins?</p>
                <img
                  className="div_cvcs"
                  src="https://files.voitto.com.br/ftp-files/assets/images/voittocoins/slide2.png"
                />
                <p className="classcal_p">Finalizar um curso</p>
                <botoes className="ui yellow basic huge fluid button fros">
                  100 VoittoCoins a cada certificado emitido
                </botoes>
              </div>

              <div>
                <p>
                  <i
                    style={{
                      zIndex: 9999999,
                      color: "black",
                      cursor: "pointer",
                      marginLeft: "94%",
                    }}
                    className="ui icon close"
                    onClick={() => this.setState({ como_ganhar: false })}
                  ></i>
                </p>
                <p className="classcal_p">Como conquistar seus VoittoCoins?</p>
                <img
                  className="div_cvcs"
                  src="https://files.voitto.com.br/ftp-files/assets/images/voittocoins/slide3.png"
                />
                <p className="classcal_p">Utilizar o VoittoApp</p>
                <botoes className="ui yellow basic huge fluid button fros">
                  250 VoittoCoins
                </botoes>
              </div>

              <div>
                <p>
                  <i
                    style={{
                      zIndex: 9999999,
                      color: "black",
                      cursor: "pointer",
                      marginLeft: "94%",
                    }}
                    className="ui icon close"
                    onClick={() => this.setState({ como_ganhar: false })}
                  ></i>
                </p>
                <p className="classcal_p">Como conquistar seus VoittoCoins?</p>
                <img
                  className="div_cvcs"
                  src="https://files.voitto.com.br/ftp-files/images/lessonCheck.png"
                />
                <p className="classcal_p">
                  A cada acerto nas questões do consolidando o conhecimento
                </p>
                <botoes className="ui yellow basic huge fluid button fros">
                  5 VoittoCoins
                </botoes>
              </div>

              <div>
                <p>
                  <i
                    style={{
                      zIndex: 9999999,
                      color: "black",
                      cursor: "pointer",
                      marginLeft: "94%",
                    }}
                    className="ui icon close"
                    onClick={() => this.setState({ como_ganhar: false })}
                  ></i>
                </p>
                <p className="classcal_p">Como conquistar seus VoittoCoins?</p>
                <img
                  className="div_cvcs"
                  src="https://files.voitto.com.br/ftp-files/images/parceria.png"
                />
                <p className="classcal_p">
                  Suas indicações convertidas em inscrições.
                </p>
                <botoes className="ui yellow basic huge fluid button fros">
                  1000 VoittoCoins
                </botoes>
              </div>

              <div>
                <p>
                  <i
                    style={{
                      zIndex: 9999999,
                      color: "black",
                      cursor: "pointer",
                      marginLeft: "94%",
                    }}
                    className="ui icon close"
                    onClick={() => this.setState({ como_ganhar: false })}
                  ></i>
                </p>
                <p className="classcal_p">Como conquistar seus VoittoCoins?</p>
                <img
                  className="div_cvcs"
                  src="https://files.voitto.com.br/ftp-files/assets/images/icons/material.png"
                />
                <p className="classcal_p">Completando seu perfil.</p>
                <botoes className="ui yellow basic huge fluid button fros">
                  200 VoittoCoins
                </botoes>
              </div>

              <div>
                <p>
                  <i
                    style={{
                      zIndex: 9999999,
                      color: "black",
                      cursor: "pointer",
                      marginLeft: "94%",
                    }}
                    className="ui icon close"
                    onClick={() => this.setState({ como_ganhar: false })}
                  ></i>
                </p>
                <p className="classcal_p">Como conquistar seus VoittoCoins?</p>
                <img
                  className="div_cvcs"
                  src="https://files.voitto.com.br/ftp-files/assets/images/voittocoins/slide6.png"
                />
                <p className="classcal_p">Os VoittoCoins expiram mensalmente</p>
                <button
                  className="ui orange button"
                  onClick={() => this.setState({ como_ganhar: false })}
                  type="submit"
                >
                  <b>Entendi</b>
                </button>
              </div>
            </Slider>
          </div>
        </center>
      </div>
    );
  }

  untilizar_ss() {
    return (
      <div>
        <center>
          <div className="ui icon header">
            <i>
              <img
                width="200"
                src="https://files.voitto.com.br/ftp-files/assets/images/voittocoin_gold.svg"
                alt="VoittoCoin"
              />
            </i>
            <br />
            Utilizar crédito
          </div>
          <br />
          <p style={{ fontSize: "10px" }}>
            Voce tem {this.state.vts ? this.state.vts : 0} VoittoCoins, isso
            equivale a R$
            {(!this.state.vts ? 0 : this.state.vts / 10).toLocaleString(
              "pt-BR",
              { minimumFractionDigits: 2, style: "currency", currency: "BRL" }
            )}
            em desconto em treinamentos digitais. Escolha seu treinamento e faça
            uso deste benefício durante o processo de inscrição.
          </p>
          <button
            className="ui orange button"
            onClick={() => this.setState({ ultiliizar: false })}
            type="submit"
          >
            <b>Entendi</b>
          </button>
        </center>
      </div>
    );
  }

  regras_view() {
    return (
      <center>
        <img
          style={{ width: 200 }}
          src="https://cdn1.iconfinder.com/data/icons/unigrid-bluetone-multimedia-vol-6/60/020_256_rules_do_not_list_book_history_education_study_learn_knowledge-512.png"
          alt=""
        ></img>
        <p>
          Regra 1 - Adesão à competição Voittocoins:
          <br />
          Todas as pessoas físicas com cadastro único no site da Voitto, na
          plataforma online e com o número de VoittoCoins maior que 0 estarão
          participando da competição.
          <br />
          <br />
        </p>

        <p>
          Regra 2 – Rodadas:
          <br />
          A competição é dividida em rodadas. Cada rodada tem duração de um mês,
          após esse período o número de Voittocoins é zerado.
          <br />
          <br />
        </p>

        <p>
          Regra 3 - Contabilidade do Acúmulo:
          <br />
          Para a classificação dos competidores é utilizado o número individual
          de Voittocoins acumulados no mês, que são intransferíveis. O uso dos
          mesmos em desconto de cursos não implica em perda de posição no
          rankeamento;
          <br />
          <br />
        </p>

        <p>
          Regra 4 - Atos geradores de Voittocoins:
          <br />
          - Evoluir nos cursos: Vt$3 por lição
          <br />
          - Finalizar um curso: Vt$100
          <br />
          - Completar dados cadastrais: Vt$200
          <br />
          - Utilizar o VoittoAPP: Vt$250
          <br />
          <br />
          <br />
        </p>

        <p>
          Regra 5 - Critérios de desempate:
          <br />
          Critério 1 - Quantidade de cursos inscritos
          <br />
          Critério 2 - Quantidade de cursos compartilhados
          <br />
          Critério 3 - Total de cursos concluídos
          <br />
          <br />
          <br />
        </p>

        <p>
          Regra 6 - Prêmios:
          <br />
          A premiação é unica para cada pessoa fisica (CPF) e pode sofrer
          variação entre os meses, podendo ser vista na tabela de rankeamento,
          no ícone de prêmio.
          <br />
          <br />
        </p>

        <p>
          Regra 7 - VoittoCoins e clubes de assinatura
          <br />
          É possível utilizar seus VoittoCoins para ganhar descontos nos planos
          dos clubes de assinatura da Voitto. No entanto, os conteúdos inclusos
          nesses planos não geram VoittoCoins.
          <br />
        </p>
        <br />
        <p>
          Regra 8 - Validade dos cursos com VoittoCoins
          <br />
          Após a inscrição, os cursos adquiridos 100% por VoittoCoins ficarão
          disponíveis por 90 dias no Portal do Aluno.
        </p>
        <p>
          Regra 9. Cancelamento de curso 100% VoittoCoins
          <br />
          Não é possível solicitar reembolso de um treinamento pago com 100% de
          VoittoCoins.
        </p>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />

        <div
          style={{
            width: "100%",
            height: "auto",
            backgroundColor: "white",
            position: "absolute",
            bottom: "10px",
            overflowX: "hidden",
            paddingTop: "10px",
          }}
        >
          <button
            className="ui orange button"
            style={{ marginLeft: "-45px" }}
            onClick={() => this.setState({ regras: false })}
            type="submit"
          >
            <b>Entendi</b>
          </button>
        </div>
      </center>
    );
  }

  pegaUltimaDiaMes(mes) {
    switch (mes) {
      case 0:
      case 2:
      case 4:
      case 6:
      case 7:
      case 9:
      case 11:
        return 31;

      case 1:
        return 28;

      case 3:
      case 5:
      case 8:
      case 10:
        return 30;
    }
  }

  brokenImg(ev) {
    if (ev.target.src.includes(".jpg")) {
      ev.target.src = ev.target.src.replace(".jpg", ".png");
      return;
    }

    if (ev.target.src.includes(".png")) {
      ev.target.src =
        "https://files.voitto.com.br/ftp-files/assets/images/user_default.png";
      ev.target.style.height = "18vw";
      ev.target.style.marginTop = "-3.5vw";
      return;
    }
  }

  render() {
    let d = new Date();
    if (this.state.load)
      return (
        <div
          className="ui simple dropdown item coper"
          id="dropper"
          tabindex="0"
          onMouseEnter={() => this.hover()}
        >
          <style>
            {`.voitto-coin-icon {
                        background-position: center center;
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-image: url(https://files.voitto.com.br/ftp-files/assets/images/voittocoinsicon.png);
                        width: 28px;
                        height: 28px;
                        display: inline-table;
                        position: relative;
                        border: none;
                        outline: none;
                        background-color: transparent;
                    }
                    `}
          </style>
          {verify_mobile() ? (
            <div style={{ display: "flex" }}>
              <i className="voitto-coin-icon"></i>
              <p
                id="item_droper"
                style={{
                  margin: "0",
                  marginTop: "10px",
                  marginLeft: "10px",
                  fontWeight: "500",
                  fontSize: "0.9rem",
                  textTransform: "uppercase",
                  color: "#fff",
                  textDecoration: "none",
                }}
              >
                VOITTOCOINS
              </p>
            </div>
          ) : (
            <i className="voitto-coin-icon"></i>
          )}
          <div
            className="menu"
            style={{
              maxHeight: "500px",
              overflow: "auto",
              overflowX: "hidden",
              width: "327px",
            }}
          >
            {this.state.load ? (
              <center>
                <p
                  style={{
                    textAlign: "center",
                    fontSize: "13px",
                    padding: "10px",
                  }}
                >
                  <b>
                    Saldo de VoittoCoins: {this.state.vts ? this.state.vts : 0}
                  </b>
                  <br />
                  isso equivale a{" "}
                  {(!this.state.vts ? 0 : this.state.vts / 10).toLocaleString(
                    "pt-BR",
                    {
                      minimumFractionDigits: 2,
                      style: "currency",
                      currency: "BRL",
                    }
                  )}{" "}
                  em desconto <br />
                  em treinamentos digitais
                  <br />
                  Expira em: {this.pegaUltimaDiaMes(d.getMonth())}/
                  {d.getMonth() + 1}/{d.getFullYear()}
                </p>
                <br />
                <div className="voittocoins_div">
                  <center>
                    <div style={{ paddingTop: "5%" }}>
                      <p
                        className="titlerank"
                        style={{ fontSize: "12px", float: "center" }}
                      >
                        <b>Ranking VoittoCoins</b>
                      </p>
                    </div>
                  </center>
                  {this.state.data.map((res) => (
                    <>
                      {res.pessoa && (
                        <div
                          className="divcontainer"
                          style={{ display: "flex" }}
                        >
                          <img
                            className="img_vts"
                            src={
                              res.pessoa.foto ||
                              "https://files.voitto.com.br/ftp-files/assets/images/no-image.jpg"
                            }
                            onError={this.brokenImage}
                          />
                          <div>
                            <p>
                              <b>{res.pessoa.nome}</b>
                              <br />
                              <b>{res.pessoa.cidade}</b>
                              <br />
                              <b>Acum. mês: {res.acumulado} Vt$</b>
                            </p>
                          </div>
                          <div className="ui divider"></div>
                        </div>
                      )}
                    </>
                  ))}
                </div>
                <button
                  className="ui orange button"
                  style={{ fontSize: 10, width: "50%" }}
                  onClick={() => this.minha_posicao()}
                  type="submit"
                >
                  <b>Ver minha posição</b>
                </button>

                <div
                  style={{
                    width: "100%",
                    height: "80px",
                    padding: "-30%",
                    marginTop: "20px",
                    backgroundColor: "#242424",
                  }}
                >
                  <div className="ui centered grid" style={{ paddingLeft: 10 }}>
                    <div className="seven wide column">
                      <button
                        className="ui orange button"
                        onClick={() => this.setState({ ultiliizar: true })}
                        style={{ fontSize: 10, width: "110.5%" }}
                        type="submit"
                      >
                        Ultilizar créditos
                      </button>
                    </div>

                    <div className="seven wide column">
                      <button
                        className="ui  button"
                        onClick={() => {
                          this.setState({ como_ganhar: true });
                        }}
                        style={{
                          fontSize: 10,
                          width: "110.5%",
                          marginLeft: "-10px",
                        }}
                        type="submit"
                      >
                        Como ganhar
                      </button>
                    </div>
                  </div>

                  <div>
                    <button
                      className="ui orange button"
                      onClick={() => this.setState({ regras: true })}
                      style={{
                        fontSize: 10,
                        width: "85%",
                        marginLeft: "5%",
                        marginTop: "5px",
                      }}
                      type="submit"
                    >
                      Regras
                    </button>
                  </div>
                </div>
              </center>
            ) : (
              <div>
                <center>
                  <ReactLoading
                    type={"bars"}
                    color={"#242424"}
                    height={"100%"}
                    width={"100%"}
                  />
                </center>
              </div>
            )}
            <Modal
              isOpen={this.state.modalIsOpen}
              style={customStyles}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModal}
              contentLabel="Example Modal"
            >
              <div>{this.position_minha()}</div>
            </Modal>

            <Modal
              isOpen={this.state.ultiliizar}
              style={customStyles}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModal}
              contentLabel="Example Modal"
            >
              <div>{this.untilizar_ss()}</div>
            </Modal>

            <Modal
              isOpen={this.state.como_ganhar}
              style={customStyles}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModal}
              contentLabel="Example Modal"
            >
              {this.como_ganhar_view()}
            </Modal>
            <Modal
              isOpen={this.state.regras}
              style={customStyles}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModal}
              contentLabel="Example Modal"
            >
              <div style={{ overflowY: "scroll", height: "500px" }}>
                {this.regras_view()}
              </div>
            </Modal>
          </div>
        </div>
      );
    else return null;
  }
}
